var React = require('react');

function FunnelIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0284 0H0.971595C0.564908 0 0.328346 0.459685 0.564728 0.790619L5 7V11.5C5 11.7761 5.22386 12 5.5 12H6.5C6.77614 12 7 11.7761 7 11.5V7L11.4353 0.790619C11.6717 0.459685 11.4351 0 11.0284 0Z","fill":"#33445E"}));
}

FunnelIcon.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = FunnelIcon;

FunnelIcon.default = FunnelIcon;
